import { generateTestId } from "@client-shared";

export const setRequiredVariantHintTestId = (identifier: string): string => generateTestId("RequiredVariantHint", identifier);
